import { useEffect, useState } from 'react';
import If from 'Views/Components/If/If';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import HandleEvents from 'Util/HandleEvents';
import useStore from 'Hooks/useStore';
import { observer } from 'mobx-react';

export type ProductType = 'hub' | 'monitor' | 'approve';

export interface ProductSwitcherProps {
	productClass: ProductType
}

const ProductSwitcher = observer((props: ProductSwitcherProps) => {
	const { productClass } = props;
	const [expanded, setExpanded] = useState(false);

	const store = useStore();
	const approveLoginUrl = `${store.appSettings.approveBaseUrl}${store.appSettings.approveLoginPath}`;
	const ppsrLoginUrl = `${store.appSettings.ppsrBaseUrl}${store.appSettings.ppsrLoginPath}`;

	useEffect(() => {
		// Reset product switcher if organisation changes
		setExpanded(false);
	}, [store.getUser?.organisation?.id]);

	return (
		<>
			<div
				className={classNames('nav__home', { expanded: expanded })}
			>
				<span
					className={classNames('nav-home-toggle icon-apps icon-right', { expanded: expanded })}
					role="button"
					aria-label="Product switcher toggle"
					tabIndex={0}
					{...HandleEvents(() => setExpanded(!expanded))}
				>
					<div
						className={classNames('nav-logo', productClass, { expanded: expanded })}
						role="img"
						aria-label="Product Switcher"
					/>
				</span>
				<If condition={expanded}>
					<div className="product-switcher-overlay">
						<If condition={store.canAccessIntel || store.canAccessApprove || store.canAccessPPSR}>
							<p className="product-switcher-description">Switch to</p>
						</If>
						<If condition={store.canAccessApprove}>
							<a
								className="product-wrap"
								href={approveLoginUrl}
								aria-label="Approve"
								target="_blank"
								rel="noreferrer"
							>
								<div className="product-logo light-blue" role="img" aria-label="Approve logo">
									<div className="nav-logo approve" />
								</div>
								<span>Approve (Applications)</span>
							</a>
						</If>
						<If condition={store.canAccessPPSR}>
							<a
								className="product-wrap"
								href={ppsrLoginUrl}
								aria-label="PPSR"
								target="_blank"
								rel="noreferrer"
							>
								<div className="product-logo blue" role="img" aria-label="PPSR logo">
									<div className="nav-logo ppsr" />
								</div>
								<span>PPSR (Securities)</span>
							</a>
						</If>
						<If condition={store.canAccessIntel}>
							<a
								className="product-wrap"
								href={'/monitor/dashboard'}
								aria-label="Monitor"
								target="_blank"
								rel="noreferrer"
							>
								<div className="product-logo purple" role="img" aria-label="Monitor logo">
									<div className="nav-logo intel" />
								</div>
								<span>Monitor (Tracking)</span>
							</a>
						</If>
						<Link
							to="/hub/products"
							target="_blank"
							className="access-hub-link icon-home-2 icon-left"
							aria-label="AccessHub"
						>
							AccessHub
						</Link>
					</div>
				</If>
			</div>
		</>
	);
});

export default ProductSwitcher;
